import features from 'lib/common/features';
import has from 'lodash/has';
import isFunction from 'lodash/isFunction';

function defaultSummaryTitle(seatData) {
    let parts = [];
    if (has(seatData, 'screen.screen_desc')) {
        parts.push(seatData.screen.screen_desc);
    }
    if (has(seatData, 'seat_row')) {
        parts.push(`Row ${seatData.seat_row}`);
    }
    if (has(seatData, 'seat_num')) {
        parts.push(`Seat ${seatData.seat_num}`);
    }

    return parts.join(', ');
}

export default function summaryTitle(seatData, customiserFn) {
    customiserFn = customiserFn || features.getOption('customSeatDescription', 'customiser');

    if (isFunction(customiserFn)) {
        return customiserFn.call(null, seatData);
    } else {
        return defaultSummaryTitle(seatData);
    }

}



// WEBPACK FOOTER //
// ./src/javascripts/app/lib/seats/summaryTitle.js